<template>
  <div class="order-update">
    <NavHeaderBar :navBarTitle="$t('shared.title.orderUpdateRecord')" :showSearch="false" />
    <van-pull-refresh v-model="isRefreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="$t('tips.noMoreData')"
        :immediate-check="false"
        :offset="60"
        @load="onLoad"
      >
        <div
          v-for="item in recordList"
          :key="item.id"
          class="record-item"
        >
          <div class="record-header">
            <span class="record-time">{{ item.localCreateTime }}</span>
            <span class="record-user">{{ item.createUserName }}</span>
          </div>
          <div class="edit-reason">
            <span class="reason-label">{{ $t('form.editReason') }}：</span>
            <span class="reason-text">{{ item.remark }}</span>
          </div>
          <van-collapse v-model="item.activeNames" class="change-collapse">
            <van-collapse-item :name="String(item.id)" class="change-collapse-item">
              <template #title>
                <span class="change-title">{{ $t('shared.changeDetails') }}</span>
              </template>
              <div class="change-content">
                <div v-if="item.removeMap && Object.keys(item.removeMap).length > 0" class="change-section">
                  <div class="section-title removed-products">·{{ $t('shared.removedProducts') }}</div>
                  <div v-for="(subItem, subKey, subIndex) in item.removeMap" :key="subIndex">
                    <div v-for="(listItem, listIndex) in subItem" :key="listIndex" class="change-line">
                      {{ listItem.projectName }}·{{ listItem.productName }}：{{ subKey ? $t('shared.quanntityGivenAway') : $t('shared.quanntitySold') }} {{ listItem.oldQuantity }} {{ $t('form.pcs') }} → {{ listItem.newQuantity }} {{ $t('form.pcs') }}
                    </div>
                  </div>
                </div>
                <div v-if="item.updateMap && Object.keys(item.updateMap).length > 0" class="change-section">
                  <div class="section-title modified-quantity">·{{ $t('shared.modifiedProductQuantity') }}</div>
                  <div v-for="(subItem, subKey, subIndex) in item.updateMap" :key="subIndex">
                    <div v-for="(listItem, listIndex) in subItem" :key="listIndex">
                      <div class="change-line">
                        {{ listItem.projectName }}·{{ listItem.productName }} : {{ [true, 'true'].includes(subKey) ? $t('shared.quanntityGivenAway') : $t('shared.quanntitySold') }} {{ listItem.oldQuantity }} {{ $t('form.pcs') }} → {{ listItem.newQuantity }} {{ $t('form.pcs') }}
                      </div>
                      <div v-if="listItem.specList && listItem.specList.length > 0" class="sku-changes">
                        <div v-for="(specItem, specIndex) in listItem.specList" :key="specIndex" class="sku-line">
                          # {{ specItem.specName }} {{ $t('shared.from') }} {{ specItem.oldQuantity }} {{ $t('form.pcs') }} {{ $t('shared.to') }} {{ specItem.newQuantity }} {{ $t('form.pcs') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="Object.keys(item.changeSdMap).length > 0" class="change-section">
                  <div class="section-title removed-distributor">·{{ $t('shared.removedDistributor') }}</div>
                  <div v-for="(subItem, subKey, subIndex) in item.changeSdMap" :key="subIndex" class="change-line">
                    {{ subKey }}: {{ subItem.map(mapItem => mapItem.sdName).join('，') }}
                  </div>
                </div>
                <div v-if="Object.keys(item.removeMap).length <= 0 && Object.keys(item.updateMap).length <= 0 && Object.keys(item.changeSdMap).length <= 0">{{ $t('shared.none') }}</div>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import NavHeaderBar from '@/components/NavHeaderBar'
import { changeListPageApi } from '@/api/shared'
import { Toast } from 'vant'

export default {
  name: 'OrderUpdate',
  components: {
    NavHeaderBar
  },
  data () {
    return {
      isRefreshing: false,
      loading: false,
      finished: false,
      recordList: [],
      page: 1,
      pageSize: 10,
      total: 35,
      paramsUrl: {}
    }
  },
  activated () {
    this.paramsUrl = this.$route.query
    this.resetList()
    this.onLoad()
  },
  methods: {
    hasChanges (changes) {
      // return (changes.removedProducts && changes.removedProducts.length) ||
      //   (changes.modifiedProducts && changes.modifiedProducts.length) ||
      //   (changes.removedDistributors && changes.removedDistributors.length)
      return true
    },
    resetList () {
      this.recordList = []
      this.page = 1
      this.finished = false
      this.loading = false
    },
    onLoad () {
      // 同步置为 true，防止 van-list 检测到内容不足时自动补发 load 导致重复调用
      this.loading = true
      const data = {
        ...this.paramsUrl,
        page: this.page,
        limit: 10
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      changeListPageApi(data).then(res => {
        Toast.clear()
        res.data.list.forEach(subItem => {
          subItem.activeNames = [subItem.id + '']
        })
        this.recordList = [...this.recordList, ...res.data.list]
        this.total = Number(res.data.totalRow)
        this.page++
        this.loading = false
        if (this.recordList.length >= this.total) {
          this.finished = true
        }
      }).catch(() => {
        Toast.clear()
        this.loading = false
      })
    },
    onRefresh () {
      this.resetList()
      this.page = 1
      this.onLoad()
      this.isRefreshing = false
    }
  }
}
</script>

<style lang="less" scoped>
.order-update {
  font-size: 12px;
  min-height: 100vh;
  background-color: #f5f5f9;
}

.record-item {
  background-color: #fff;
  padding: 10px 13px;
  border-bottom: 1px solid #f0f0f0;
}

.record-header {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  font-size: 13px;
  color: #333;
  .record-time {
    margin-right: 10px;
  }
}

.edit-reason {
  line-height: 22px;
  .reason-label {
    color: #307bff;
    font-weight: bold;
  }
  .reason-text {
    color: #333;
    word-break: break-word;
  }
}

.change-collapse {
  /deep/.van-cell {
    padding: 8px 0;
    line-height: 24px;
    background-color: transparent;
    &::after {
      display: none;
    }
  }
  /deep/.van-cell__right-icon {
    color: #999;
  }
  /deep/.van-collapse-item__title {
    font-size: 12px;
    font-weight: 500;
    color: #333;
    padding: 3px 0;
  }
  /deep/.van-collapse-item__wrapper {
    .van-cell {
      padding: 0;
    }
  }
  /deep/.van-collapse-item__content {
    padding: 0;
  }
}
/deep/.van-hairline--top-bottom::after {
  display: none;
}

.change-content {
  padding: 10px;
  font-size: 12px;
  background-color: #f2f2f2;
  border-radius: 8px;
}

.change-section {
  margin-bottom: 6px;
  &:last-child {
    margin-bottom: 0;
  }
}

.section-title {
  font-weight: bold;
  &.removed-products {
    color: #e64340;
  }
  &.modified-quantity {
    color: #c08a00;
  }
  &.removed-distributor {
    color: #8a2be2;
  }
}

.change-line {
  color: #333;
  line-height: 22px;
  padding-left: 12px;
  word-break: break-word;
}

.sku-changes {
  padding-left: 24px;
}

.sku-line {
  color: #333;
  line-height: 22px;
}

.none-text {
  color: #999;
}
</style>
